import axios from "axios";
axios.defaults.withCredentials = true;

export const insertData = async(path, setResponse, data) =>{
    try {
        console.log("path",path)
        const listDate = await axios.post(`${process.env.REACT_APP_API_URL}/${path}`, data);
        console.log("insert responseData --",listDate.data?.message)
        setResponse(listDate?.data?.message);
        return true;
    } catch (error) {
        console.log("error in insert",error)
        setResponse(error?.response?.data?.message);
        return false;
    }
}